/**
 * Authorization Roles
 */

// export const authRoles = {
//     admin    : ['admin'],
//     staff    : ['admin', 'staff'],
//     user     : ['admin', 'staff', 'user'],
//     onlyGuest: ['guest']
// };

const SUPERADMIN = 'ROLE_SUPER_ADMIN';
const ADMIN = 'ROLE_ADMIN';
const EDITOR = 'ROLE_EDITOR';
const VIEWER = 'ROLE_VIEWER';
const GUEST = 'guest';

export const authRoles = {
    superAdmin: [SUPERADMIN],
    admin: [ADMIN, SUPERADMIN],
    editor: [ADMIN, EDITOR],
    viewer: [ADMIN, EDITOR, VIEWER],
    onlyGuest: [GUEST],
    exceptGuest: [ADMIN, EDITOR, VIEWER],
    exceptViewer: [SUPERADMIN, ADMIN, EDITOR]
};

export const isAllowed = (user, roles) =>
    roles.includes(user.role);


// WEBPACK FOOTER //
// ./src/auth/auth.js